import OpenApiConfiguration from 'api/OpenApiConfiguration';
import { useMutation, useQueryClient } from 'react-query';
import { BookingsApi } from 'swagger/apis/bookings-api';

const bookingsApi = new BookingsApi(OpenApiConfiguration);

// marks conversation as read and possibly archives it
export default function useReadArchiveMessageMutation(conversationId, bookingId, options?) {
  const queryClient = useQueryClient();

  const patchMessageMutation = useMutation(
    ({ archive = false, read = true }: { archive?: boolean; read?: boolean }) =>
      bookingsApi.domesticV2BookingsIdMessagesPatch(bookingId, { archived: archive, read }),
    {
      mutationKey: 'messageRead',
      onSuccess: (...params) => {
        queryClient.invalidateQueries('userInboxCount');
        queryClient.invalidateQueries('conversationsTab');
        options?.onSuccess(...params);
      },
    }
  );

  return patchMessageMutation;
}
